import React from "react";
import { useTranslation } from "react-i18next";

import { WidgetKind } from "../../../../model/widget/types/WidgetKid.enum";
import { TestIDs } from "../../../../tests/types/testIds";
import { PageIcons } from "../../../../utils/GlobalIcons";
import { ReportsByUserChartStackWithClosed } from "../../../reports/components/tabs/ReportsByChartStackWithClosed";
import { DashboardPanel } from "../DashboardPanel";

export const WidgetStatsClosedEntities: React.FC = () => {
  const { t } = useTranslation();

  return (
    <DashboardPanel
      title={t("dashboard.widget.title.Closed Entities")}
      cta={{
        to: "/reports",
        label: t("dashboard.widget.report.btn"),
        icon: PageIcons.Reports,
        testId: TestIDs.dashboard.widgets[WidgetKind.CLOSED_ENTITIES].cta,
      }}
      dataTestId={TestIDs.dashboard.widgets[WidgetKind.CLOSED_ENTITIES].wrapper}
    >
      <ReportsByUserChartStackWithClosed displayAsWidget />
    </DashboardPanel>
  );
};
